const ASSIGNED_MACHINE_KEY = 'assignedMachine';

function getAssignedMachine() {
    const raw = localStorage.getItem(ASSIGNED_MACHINE_KEY);
    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch (error) {
        localStorage.removeItem(ASSIGNED_MACHINE_KEY);
        return null;
    }
}

function setAssignedMachine(machine) {
    if (!machine) {
        localStorage.removeItem(ASSIGNED_MACHINE_KEY);
        return;
    }
    localStorage.setItem(ASSIGNED_MACHINE_KEY, JSON.stringify(machine));
}

function clearAssignedMachine() {
    localStorage.removeItem(ASSIGNED_MACHINE_KEY);
}

export { getAssignedMachine, setAssignedMachine, clearAssignedMachine };
